var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    {
      attrs: {
        clientId: _vm.clientId,
        channels: _vm.channels,
        setTitle: _vm.title,
        apiOrigin: _vm.apiOrigin
      }
    },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "article" },
          [
            _c("div", { staticClass: "searchText" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchKey,
                    expression: "searchKey"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.searchKey },
                on: {
                  keyup: function($event) {
                    if (!("button" in $event) && $event.keyCode !== 13) {
                      return null
                    }
                    _vm.getSearch($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchKey = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: { src: "/public/w/img/pc/search-03.png", alt: "" },
                on: { click: _vm.getSearch }
              })
            ]),
            _vm._v(" "),
            _c("publicList", { attrs: { list: _vm.newsList } }),
            _vm._v(" "),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.meta.cur_page < _vm.meta.total_page,
                    expression: "meta.cur_page<meta.total_page"
                  }
                ],
                staticClass: "more",
                attrs: {
                  disabled: _vm.showMore == "加载中",
                  href: "javascript:;",
                  id: "pc-more"
                },
                on: { click: _vm.more }
              },
              [_vm._v(_vm._s(_vm.showMore ? _vm.showMore : "加载更多"))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.meta.cur_page == _vm.meta.total_page,
                    expression: "meta.cur_page==meta.total_page"
                  }
                ],
                staticClass: "more",
                attrs: { href: "javascript:;", id: "pc-more" }
              },
              [_vm._v("没有更多了")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "aside" },
          [
            _c("newsImgAside", {
              attrs: {
                title: "热门新闻",
                list: _vm.reWenList,
                clientId: _vm.clientId
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-799ec883", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-799ec883","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/page/news-pc/search.vue
// module id = null
// module chunks = 